// Utils
import { getEnvironmentApiUrl } from "../../../services/General";

// Hooks
import { useState, useEffect } from "react";
import useHttp from "../../../hooks/useHttp";

// Models
import { Role, UserData } from "../../../interfaces/UserInfo";

const useFetchDataEditUser = () => {

    const { sendRequest: getReferenceDoctors } = useHttp<UserData[]>();
    const { sendRequest: getRoles } = useHttp<Role[]>();

    const [referenceDoctors, setReferenceDoctors] = useState<UserData[]>([]);
    const [roles, setRoles] = useState<Role[]>([])

    useEffect(() => {
        getReferenceDoctors({
            url: getEnvironmentApiUrl() + 'user/all',
            method: 'POST',
            body: { params: {}, filter: { is_reference_doctor: true, enabled_bchome: true } }
        }, (data) => setReferenceDoctors(data))
    }, [getReferenceDoctors]);

    useEffect(() => {
        getRoles({
            url: getEnvironmentApiUrl() + 'role/all',
            method: 'POST',
            body: { params: {}, filter: {} }
        }, (data) => setRoles(data))
    }, [getRoles]);

    return { roles, referenceDoctors }
}

export default useFetchDataEditUser;